module.exports = __webpack_public_path__ + "img/0298a6424beeba080dbd2518cac140af.png";